import lazyLoad from './lazyLoad';
export default class UpdateCart {
    constructor() {
        this.initListeners();
    }

    initListeners = () => {
        // jQuery(function ($) {
        //     $('.woocommerce').on('change', 'input.qty', function () {
        //         jQuery('.woocommerce-cart-form :input[name="update_cart"]').prop('disabled', false);
        //         $("[name='update_cart']").trigger('click');
        //     });
        // });

        jQuery(document).on('ajaxComplete', (e) => {
            lazyLoad();
        });
    };
}
